<template>
  <div id="app">
    <Header class="fixed-header" ref="fixedHeader" />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/header/Header.vue";
import Footer from "@/components/footer/Footer.vue";

export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      headerHeight: 0,
      setCeilingLampHandler: null,
      appLayerStyle: {},
    };
  },
};
</script>

<style lang="scss" scoped>
#app {
  position: relative;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin: 0 auto;
  padding-top: var(--head-height);
  width: 100vw;
  // background-color: #eee;
}
</style>



// WEBPACK FOOTER //
// src/App.vue